import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c8a79dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "row align-items-center pt-3 border-top border-1 border-black border-opacity-25 flex-nowrap" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubmittingOverlay = _resolveComponent("BaseSubmittingOverlay")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_AutoSaveFeedback = _resolveComponent("AutoSaveFeedback")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.pinnedFooter ? 'pinned-root' : '')
  }, [
    (!_ctx.hideOverlayAndAlert)
      ? (_openBlock(), _createBlock(_component_BaseSubmittingOverlay, {
          key: 0,
          "is-submitting": _ctx.pageUI.isSubmitting() || _ctx.pageUI.isDeleting() || _ctx.pageUI.isAnyItemDeleting()
        }, null, 8, ["is-submitting"]))
      : _createCommentVNode("", true),
    (!_ctx.hideOverlayAndAlert)
      ? (_openBlock(), _createBlock(_component_AlertError2, {
          key: 1,
          error: _ctx.pageUI.getError()
        }, null, 8, ["error"]))
      : _createCommentVNode("", true),
    (!_ctx.pageUI.isReady())
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 2 }))
      : (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(['d-flex flex-column justify-content-between h-100', _ctx.pinnedFooter ? 'pinned-fill' : ''])
        }, [
          _createVNode(_component_Form, {
            class: _normalizeClass(_ctx.pinnedFormClass),
            novalidate: "",
            onInvalidSubmit: _ctx.onInvalidSubmit
          }, {
            default: _withCtx(({ errors, handleSubmit }) => [
              _createElementVNode("form", {
                ref: "formElement",
                onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.submitData)), ["prevent"]),
                class: _normalizeClass(_ctx.pinnedFormClass)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(['col-12', _ctx.pinnedFooter ? 'pinned-content' : ''])
                }, [
                  _renderSlot(_ctx.$slots, "content", { errors: errors }, undefined, true)
                ], 2),
                (!_ctx.hideButtons)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(['d-flex flex-column mb-2', _ctx.pinnedFooter ? 'pinned-buttons' : ''])
                    }, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                          class: _normalizeClass(`col-auto buttons-row gap-2 d-flex flex-row align-items-center ${_ctx.buttonsRowClass}`)
                        }, [
                          (!_ctx.hideFeedbackStatus && _ctx.pageUI.getAutoSaveFeedbackStatus() !== _ctx.AutoSaveFeedbackStatusEnum.NONE && _ctx.alignButtonsRight)
                            ? (_openBlock(), _createBlock(_component_AutoSaveFeedback, {
                                key: 0,
                                wrapperClass: "auto-save-feedback flex-shrink-1",
                                status: _ctx.pageUI.getAutoSaveFeedbackStatus()
                              }, null, 8, ["status"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "submit",
                            class: _normalizeClass(`btn btn-primary ${_ctx.buttonClass}`),
                            disabled: !_ctx.pageUI.canSubmit() || _ctx.pageUI.isSubmitting()
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.submitButtonTranslationKey)) + " ", 1),
                            (_ctx.pageUI.isSubmitting())
                              ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_3),
                          _renderSlot(_ctx.$slots, "buttons", {}, undefined, true),
                          (!_ctx.hideFeedbackStatus && _ctx.pageUI.getAutoSaveFeedbackStatus() !== _ctx.AutoSaveFeedbackStatusEnum.NONE && !_ctx.alignButtonsRight)
                            ? (_openBlock(), _createBlock(_component_AutoSaveFeedback, {
                                key: 1,
                                wrapperClass: "auto-save-feedback flex-shrink-1",
                                status: _ctx.pageUI.getAutoSaveFeedbackStatus()
                              }, null, 8, ["status"]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _renderSlot(_ctx.$slots, "belowButtons", {}, undefined, true)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_1)
            ]),
            _: 3
          }, 8, ["class", "onInvalidSubmit"])
        ], 2))
  ], 2))
}